import { FormattedDate } from 'react-intl';
import styled from 'styled-components';
import { VictoryLabelProps, VictoryTooltip, VictoryTooltipProps } from 'victory';
import { TooltipStyle } from './tooltip-style';
import { FormattedMoney } from '../atomic-components';
import { BankHistory } from '@algoan/dashboard/model';

const BalanceLabel: React.FC<VictoryLabelProps> = (props) => {
  const { x = 0, y = 0 } = props;
  const datum = props.datum as BankHistory;
  const isPositive = datum.balance > 0;

  return (
    <g>
      {/* foreignObject must have a fixed size. The values here are arbitrary. In the case
        where the tooltip is bigger than the foreignObject, it is still visible thanks to
        overflow property  */}
      <foreignObject x={x + 5} y={y + 20} width="100" height="25" overflow="visible">
        <TooltipStyle.Tooltip>
          <TooltipStyle.Date>
            <FormattedDate value={datum.date} day="numeric" month="numeric" />
          </TooltipStyle.Date>
          <TooltipStyle.Divider />
          <S.Balance isPositive={isPositive}>
            <FormattedMoney number={datum.balance} />
          </S.Balance>
        </TooltipStyle.Tooltip>
      </foreignObject>
    </g>
  );
};

export type BalanceTooltipProps = VictoryTooltipProps;

export const BalanceTooltip: React.FC<BalanceTooltipProps> = (props) => {
  return <VictoryTooltip {...props} labelComponent={<BalanceLabel />} flyoutComponent={<div />} />;
};

const S = {
  Balance: styled.div<{ isPositive: boolean }>`
    margin: 4px;
    font-weight: bold;
    font-size: 9px;
    line-height: 11px;
    color: ${({ isPositive, theme }) => (isPositive ? theme.legacy.green : theme.legacy.red)};
  `,
};
